<template>
  <div>
    <v-form ref="inputForm" @submit.prevent="">

      <v-row>
        <v-col cols="12" md="6">
          <Combobox
            v-if="elsInUse.DrawdownMethodID"
            v-model="drawdownMethod"
            :returnObject="true"
            :items="drawdownDS" 
            :label="elsLabel.DrawdownMethodID"
            :helperText="elsHelperText.DrawdownMethodID"
            @input="_drawdownMethodChange"
            :rules="[elsRequired.DrawdownMethodID ? rules.required : true]">
          </Combobox>
        </v-col>
      </v-row>
      
      <v-row class="table--gray" v-if="enforceDrawdown">
        <v-col cols="12" md="12">
          <v-expand-transition>
              <AccountDetails
                v-model="model.drawdownAccount"
                propertyModelName="Drawdown"
                :rules="rules">
              </AccountDetails>
          </v-expand-transition>
        </v-col>
      </v-row>

      <StepperButtons 
        @continueClick="_stepperContinue"
        @backClick="_stepperBack">
      </StepperButtons>

    </v-form>

  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import AccountDetails from './account-details.vue'
  import Combobox from '@/shared/components/combobox.vue';
  import StepperButtons from './stepper-buttons.vue'
  import opmGeneric from '../utils/generic.js';
  import constants from '../constants/generic.js';

  export default {
    name: 'Drawdown',
    components: { 
      StepperButtons, 
      AccountDetails, 
      Combobox
    },
    props: {
      rules: { type: Object },
    }, 
    emits: ["continueClick", "backClick"],
    data() {
      return {
        enforceDrawdown: undefined,
        drawdownDS: [],
        drawdownMethod: undefined,
        model: {
          drawdownMethodID: undefined,
          drawdownAccount: {},
        }
      };
    },
    created() { 
        opmGeneric.setElementsConfig(this, this.elementsConfig); 
        // DropdownLists sources
        this.drawdownDS = this.referenceData ? this.referenceData.DrawdownMethods : [];
    },
    methods: {
      _stepperContinue() { 
        this.model.drawdownMethodID = this.drawdownMethod?.ID; // from Object to ID
        this.$emit("continueClick", this.model, this.$refs.inputForm); 
      },

      _stepperBack() { 
        this.$emit("backClick"); 
      },

      _drawdownMethodChange($event) {
        this.enforceDrawdown = $event.WebCode === constants.EFT;
      },
    },
    computed: {
      ...mapGetters(["referenceData", "elementsConfig"]),
    }
  };
</script>

<style lang="scss" scoped>

</style>